// extracted by mini-css-extract-plugin
export default {"products":"Products_products__4TUD3","item":"Products_item__OsMJF"};